import { computed, defineComponent, onBeforeMount, reactive, ref } from 'vue';
import CurrencyListItem from '@/components/currency/CurrencyListItem.vue';
import listOfCurrencies from '@/utils/currencies';
import { SearchInput } from '@yellowcard/components-library-vue3';
import useTransactionsStore from '@/store/modules/transactions';
import { useGeneralStore } from '@/store/modules/general';
import { storeToRefs } from 'pinia';
import { TransactTypes } from '@/types/transact';
export default defineComponent({
    name: 'ListCurrencies',
    emits: ['selected'],
    components: {
        CurrencyListItem,
        SearchInput,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const generalStore = useGeneralStore();
        const { coinCurrencySelect } = storeToRefs(generalStore);
        const { currentStep, buyCryptoList, rates } = storeToRefs(transactionsStore);
        const partnerRates = rates.value.filter(rate => rate.locale !== 'crypto');
        function filterPartnerCurrency(currency) {
            const [symbol, locale] = currency.symbol.split('_');
            if (!locale)
                return !!partnerRates.find(rate => rate.code === symbol);
            return !!partnerRates.find(rate => rate.code === symbol && rate.locale === locale);
        }
        const availableCurrencies = ref(listOfCurrencies.filter(filterPartnerCurrency));
        const filteredCurrencies = ref(availableCurrencies.value);
        const filteredCoins = ref(buyCryptoList.value);
        const userInput = reactive({
            searchInput: '',
        });
        onBeforeMount(() => {
            userInput.searchInput = '';
            filteredCoins.value = buyCryptoList.value;
        });
        function searchCoin(event) {
            if (!event.target.value) {
                filteredCoins.value = buyCryptoList.value;
                return;
            }
            filteredCoins.value = buyCryptoList.value.filter(coin => {
                const value = event.target.value?.toLocaleLowerCase();
                const currencyName = coin.name.toLocaleLowerCase();
                const currencySymbol = coin.symbol.toLocaleLowerCase();
                return currencyName.includes(value) || currencySymbol?.includes(value);
            });
        }
        function searchCurrency(event) {
            if (!event.target.value) {
                filteredCurrencies.value = availableCurrencies.value;
                return;
            }
            // filter currencies
            filteredCurrencies.value = availableCurrencies.value.filter(currency => {
                const value = event.target.value?.toLocaleLowerCase();
                const currencyName = currency.name.toLocaleLowerCase();
                const currencySymbol = currency.symbol.toLocaleLowerCase();
                return currencyName.includes(value) || currencySymbol.includes(value);
            });
        }
        const onKeyup = (event) => {
            switch (coinCurrencySelect.value) {
                case 'Coin':
                    searchCoin(event);
                    break;
                case 'Currency':
                    searchCurrency(event);
                    break;
                default:
                    console.log('Invalid option');
            }
        };
        const placeholder = computed(() => `Search for a ${coinCurrencySelect.value.toLowerCase()}`);
        const onBackClickListener = async () => {
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        const onKeyPress = () => {
            console.log();
        };
        const onCurrencySelected = async (evt) => {
            const [currency, countryCode] = evt.split('_');
            transactionsStore.setSelectedCurrency({ currency, countryCode });
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        const onCryptoSelected = async (token, standard, networkType) => {
            transactionsStore.setSelectedCrypto(token, standard, networkType);
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        return {
            listOfCurrencies,
            onBackClickListener,
            placeholder,
            onKeyPress,
            onCurrencySelected,
            onCryptoSelected,
            coinCurrencySelect,
            userInput,
            filteredCurrencies,
            filteredCoins,
            onKeyup,
        };
    },
});
